require('./rateStatus.tpl.html');
require('./rateStatusRepository.js');
require('./rateStatusRow/rateStatusRowComponent.js');
const locale = require('./rateStatus.i18n.json');

/*@ngInject*/
const RateStatusController = function ($rootScope, $scope, $state, coreConstant, configurationMediator,
                                       localization, stateRateAction, configurationActionsUtil,
                                       databaseDownloadSectionName, coreMediator, configurationConstant,
                                       modalUtil, currentUserModel, authorizationConstants, navigationStateModel,
                                       loadingBarHandler) {

    $scope.i18n = locale;
    $scope.actions = [];

    $scope.context = {
        identifier: 'stateRate',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };

    $scope.viewModel = {
        stateRates:[],
        locations:[],
        products:[],
        statuses:[],
        requestParams: {
            key: 'state',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc'
        },
        isEmptyRow:false,
        hasUnsavedChanges:false,
        isValidToSave:true,
        isReadOnly : !currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_STATE_RATES),
    };

    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

    $scope.$on(configurationConstant.event.STATE_RATE_DELETED, function (event, stateRateID) {
        if($scope.viewModel.stateRates.length === 1) {
            $scope.viewModel.isEmptyRow = true;
            createEmptyStateRate();
        } else {
            $scope.viewModel.stateRates = _.remove($scope.viewModel.stateRates, function (item) {
                return item.id !== stateRateID;
            });
        }
        $scope.validateAction();
    });

    $scope.$on(configurationConstant.event.STATE_RATE_COPY, function (event, stateRate) {
        let newStateRate = {
                country: stateRate.country,
                effectiveDateRangeBegin: null,
                effectiveDateRangeEnd: null,
                id: _.random(-100, -99999),
                objectUri: null,
                productTemplateShortName: stateRate.productTemplateShortName,
                rateApproved: null,
                state: stateRate.state,
                status: null,
                uri: null
            },
            count = 0,
            matchIndex = 0;

        _.each($scope.viewModel.stateRates, (item) => {
            if(item.id === stateRate.id) {
            matchIndex = count + 1;
            return;
        }
        count++;
    });

        $scope.viewModel.isEmptyRow = false;
        $scope.viewModel.stateRates.splice( matchIndex, 0, newStateRate );
        processActions($scope.actions);
    });

    $scope.validateAction = function () {
        let isDirtyData = false;
        _.each($scope.viewModel.stateRates, (stateRate) => {
            if(!isDirtyData) {
                if (_.isNil(stateRate.effectiveDateRangeBegin) ||
                    _.isNil(stateRate.effectiveDateRangeEnd) ||
                    _.isNil(stateRate.productTemplateShortName) ||
                    _.isNil(stateRate.status) ||
                    _.isNil(stateRate.state)) {
                    $scope.viewModel.isValidToSave = false;
                    $scope.viewModel.hasUnsavedChanges = true;
                    isDirtyData = true;
                } else {
                    $scope.viewModel.isValidToSave = true;
                    $scope.viewModel.hasUnsavedChanges = true;
                }
            }
        });
        processActions($scope.actions);
    };

    $scope.onSortChange = function (event, params) {
        $scope.viewModel.requestParams.key = params.key;
        $scope.viewModel.requestParams.sortType = params.sortType;
        sortStateRates($scope.viewModel.stateRates);
    };

    function createEmptyStateRate() {
        $scope.viewModel.stateRates = [{
            country: null,
            effectiveDateRangeBegin: null,
            effectiveDateRangeEnd: null,
            id: _.random(-100, -99999),
            objectUri: null,
            productTemplateShortName: null,
            rateApproved: null,
            state: null,
            status: null,
            uri: null
        }];
    };

    function loadActions() {
        configurationMediator.loadStateRateActions().then( (actions) => {
            const allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: $scope.context.model.contextType
            });
            $scope.actions = allActions;
            $scope.actionsTimeLastModified = new Date().getTime();
            $scope.validateAction();
        });
    };

    function processActions(actions) {
        $scope.actions  = actions;
        $scope.actionSubTexts = {};
        _.each($scope.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === stateRateAction.SAVE || action.name === stateRateAction.DISCARD) {
                    action.enabled = false;
                    if($scope.viewModel.hasUnsavedChanges) {
                        if ($scope.viewModel.isValidToSave || action.name === stateRateAction.DISCARD) {
                            action.enabled = true;
                        }
                        if (action.name === stateRateAction.SAVE) {
                            $scope.actionSubTexts[action.name] = {
                                class: 'unsavedChanges',
                                text: $scope.i18n.stateRate.unsavedChanges
                            };
                        }
                    }
                }
            });
        });
        $scope.actionsTimeLastModified = new Date().getTime();
    };

    function sortStateRates(rates) {
        let stateRates = [];
        stateRates = _.orderBy(rates, [$scope.viewModel.requestParams.key], [$scope.viewModel.requestParams.sortType]);
        $scope.viewModel.stateRates = [];
        _.each(stateRates, (user) => {
            $scope.viewModel.stateRates.push(user);
        });
    };

    function resetNavigationState() {
        navigationStateModel.saveViewState('configuration.rateStatus', null);
    }

    function loadStateRates() {
        configurationMediator.loadStateRates().then((result) => {
            $scope.viewModel.savedStateRates = _.clone(result);
            sortStateRates(result);
            if($scope.viewModel.stateRates.length === 0) {
                $scope.viewModel.isEmptyRow = true;
                createEmptyStateRate();
            }
            coreMediator.getRemoteDataSetByName('Rate Status Locations').then(function (dataSet) {
                $scope.viewModel.locations = dataSet.items;
            });

            coreMediator.getDynamicDataSet({name:'Products - Use Rate Status Enabled'}).then(function (dataSet) {
                $scope.viewModel.products = dataSet.items;
            });

            coreMediator.getRemoteDataSetByName('State Rate Statuses').then(function (dataSet) {
                $scope.viewModel.statuses = dataSet.items;
            });
        });
    };

    $scope.handleAction = function (action, file) {
        if (action.enabled) {
            switch (action.name) {
                case stateRateAction.SAVE:
                    let stateRates = [];
                    _.each($scope.viewModel.stateRates, (item) => {
                        stateRates.push(item);
                    });
                    loadingBarHandler.showNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.loadingBar);
                    configurationMediator.saveStateRates(stateRates).then((result) => {
                        loadingBarHandler.concludeNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.savingStateRatesLoadingBar);
                        sortStateRates(result);
                        $scope.viewModel.hasUnsavedChanges = false;
                        $scope.viewModel.isValidToSave = false;
                        processActions($scope.actions);
                    });
                    break;
                case stateRateAction.DISCARD:
                    modalUtil.showConfirmationModal(null, null, null, 'stateRate.discardConfirmation', null, true, function () {
                        $state.reload();
                    });
                    break;
                case stateRateAction.BACKUP:
                    configurationActionsUtil.backup(databaseDownloadSectionName.STATE_RATES, $scope.i18n.stateRate.backup.name,
                        $scope.i18n.stateRate.backup.loadingBar, $scope.i18n.stateRate.backup.successMessage);
                    break;
                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        let isCurrentStateRateStatusManager = _.startsWith(fromState.name, 'configuration.rateStatus'),
            isTargetSameAsCurrent = toState.name === fromState.name;
        if (toState.name === 'login') {
            return;
        }
        if ($scope.viewModel.hasUnsavedChanges
            && isCurrentStateRateStatusManager
            && !isTargetSameAsCurrent) {

            event.preventDefault();
            if($scope.viewModel.isValidToSave) {
                let stateRates = [];
                _.each($scope.viewModel.stateRates, (item) => {
                    if(item.id < 0) {
                        item.id = null;
                    }
                    stateRates.push(item);
                });
                loadingBarHandler.showNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.loadingBar);
                configurationMediator.saveStateRates(stateRates).then((result) => {
                    loadingBarHandler.concludeNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.savingStateRatesLoadingBar);
                    $scope.viewModel.isValidToSave = false;
                    $scope.viewModel.hasUnsavedChanges = false;
                    $state.go(toState, toParams);
                });
            }
        } else {
            // there are no changes to be saved, do nothing
        }
    }.bind(this));

    loadActions();
    loadStateRates();
    resetNavigationState();
};

angular.module('ums.configuration')
    .controller('rateStatusController', RateStatusController);

